// extracted by mini-css-extract-plugin
export var dropdownButton = "_1t-0";
export var fullWidthDropdownButton = "_1t-1";
export var icon = "_1t-3";
export var iconPlaceholder = "_1t-2";
export var menuItemRow = "_1t-8";
export var separator = "_1t-c";
export var shortcutContainer = "_1t-7";
export var shortcutIconLg = "_1t-6";
export var shortcutIconMd = "_1t-5";
export var shortcutIconSm = "_1t-4";
export var submenuChevron = "_1t-b";
export var submenuDropdown = "_1t-9";
export var submenuTriggerRow = "_1t-a";